<template>
  <div>
    <div class="hot_product">
      <ul class="clearfix">
        <template v-for="item in hotProduct">
          <template v-for="item1 in item">
            <template v-for="item2 in item1.list">
              <li>
                <a @click="godetail(item2.id)" href="javascript:void(0);">{{item2.name}}</a>
              </li>

            </template>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hotProduct: []
    }
  },
  methods: {
    async getHostProduct() {
      const { data: res } = await this.$http.get('api/page/menu')
      if (res.code == 1) {
        this.hotProduct = res.data
      }
    },
    godetail(id) {
      this.$router.push('/detail?id=' + id)
    }
  },
  created() {
    this.getHostProduct()
  }
}
</script>

<style lang="less" scoped>
.hot_product {
  width: 100%;
  position: absolute;
  top: 60px;
  left: 200px;
  background: rgba(204, 204, 204, 0.5);
  .hot_tit {
    font-size: 16px;
    margin: 5px 0;
    color: #e83030;
    font-weight: bold;
  }
  ul {
    padding-left: 23px;
    min-height: 30px;
    line-height: 30px;
    li {
      float: left;
      margin-left: 25px;
      font-size: 18px;
      // font-weight: bold;
      color: #999;
    }
  }
}
</style>
